<template>
  <div>
    <b-form-group
      :id="$id('moreMenuApplicationPromoNameFieldset')"
      label-cols="2"
      label="Name"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoName')"
      description="The name for this menu item">
      <b-form-input
        :id="$id('moreMenuApplicationPromoName')"
        v-model="menuItem.name"
        name="name" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuApplicationPromoPhoneFieldset')"
      label-cols="2"
      label="Display on phone?"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoPhone')"
      description="Will this item be displayed on phones?">
      <b-form-checkbox
        :id="$id('moreMenuApplicationPromoPhone')"
        v-model="menuItem.phone"
        name="phone" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuApplicationPromoTabletFieldset')"
      label-cols="2"
      label="Display on tablet?"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoTablet')"
      description="Will this item be displayed on tablets?">
      <b-form-checkbox
        :id="$id('moreMenuApplicationPromoTablet')"
        v-model="menuItem.tablet"
        name="tablet" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuApplicationPromoLiteFieldset')"
      label-cols="2"
      label="Display on lite?"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoLite')"
      description="Will this item be displayed on lite versions of the application?">
      <b-form-checkbox
        :id="$id('moreMenuApplicationPromoLite')"
        v-model="menuItem.lite"
        name="lite" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuApplicationPromoPaidFieldset')"
      label-cols="2"
      label="Display on paid?"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoPaid')"
      description="Will this item be displayed on paid versions of the application?">
      <b-form-checkbox
        :id="$id('moreMenuApplicationPromoPaid')"
        v-model="menuItem.paid"
        name="paid" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuApplicationPromoIosFieldset')"
      label-cols="2"
      label="Display on iOS?"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoIos')"
      description="Will this item be displayed on iOS?">
      <b-form-checkbox
        :id="$id('moreMenuApplicationPromoIos')"
        v-model="menuItem.ios"
        name="ios" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuApplicationPromoAndroidFieldset')"
      label-cols="2"
      label="Display on Android?"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoAndroid')"
      description="Will this item be displayed on Android?">
      <b-form-checkbox
        :id="$id('moreMenuApplicationPromoAndroid')"
        v-model="menuItem.android"
        name="android" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuApplicationPromoPackageIOSFieldset')"
      label-cols="2"
      label="iOS Package Url"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoPackageIOS')"
      description="The url to the iOS package">
      <b-form-input
        :id="$id('moreMenuApplicationPromoPackageIOS')"
        v-model="menuItem.packageiOS"
        name="packageiOS" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuApplicationPromoPackageAndroidFieldset')"
      label-cols="2"
      label="Android Package Url"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoPackageAndroid')"
      description="The url for the Android package">
      <b-form-input
        :id="$id('moreMenuApplicationPromoPackageAndroid')"
        v-model="menuItem.packageAndroid"
        name="packageAndroid" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuApplicationPromoStoreURLIOSFieldset')"
      label-cols="2"
      label="iOS Store Url"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoStoreURLIOS')"
      description="The store url for the iOS application">
      <b-form-input
        :id="$id('moreMenuApplicationPromoStoreURLIOS')"
        v-model="menuItem.storeURLiOS"
        name="storeURLiOS" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuApplicationPromoStoreURLAndroidFieldset')"
      label-cols="2"
      label="Android Store Url"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoStoreURLAndroid')"
      description="The store url for the Android application">
      <b-form-input
        :id="$id('moreMenuApplicationPromoStoreURLAndroid')"
        v-model="menuItem.storeURLAndroid"
        name="storeURLAndroid" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuApplicationPromoIntentFieldset')"
      label-cols="2"
      label="Intent"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoIntent')"
      description="The Android intent">
      <b-form-input
        :id="$id('moreMenuApplicationPromoIntent')"
        v-model="menuItem.intent"
        name="intent" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuApplicationPromoDownloadTextFieldset')"
      label-cols="2"
      label="Download Text"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoDownloadText')"
      description="The download link text">
      <b-form-input
        :id="$id('moreMenuApplicationPromoDownloadText')"
        v-model="menuItem.downloadText"
        name="downloadText" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuApplicationPromoImageFieldset')"
      label-cols="2"
      label="Image"
      label-class="pt-0"
      :label-for="$id('moreMenuApplicationPromoImageUpload')"
      description="The image attached to the short content">
      <b-input-group>
        <b-form-input
          :id="$id('moreMenuApplicationPromoImageUpload')"
          v-model="menuItem.imageURL"
          name="imageURL"
          type="url"
          trim />
        <b-input-group-append>
          <b-btn
            variant="outline-primary"
            @click.prevent="$refs.assetUploadModal.show()">
            <i class="fas fa-plus" />
          </b-btn>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-modal
      id="asset-upload"
      ref="assetUploadModal"
      hide-header
      hide-footer
      size="lg">
      <asset-upload
        post-action="/api/client-content/v1/files/static/more-menu-application-promo"
        :existing-files="[]"
        :process-image-cuts="true"
        :constraint="menuItem.constraint"
        @asset-selected-response="onAssetSelect"
        @cancel="$refs.assetUploadModal.hide()" />
    </b-modal>
  </div>
</template>

<script>
import AssetUpload from '@/components/AssetUpload'

export default {
    name: 'MoreMenuApplicationPromo',
    components: {
        AssetUpload,
    },
    props: {
        value: {
          type: Object,
          required: true,
        },
    },
    computed: {
      CLOUDINARY_ACCOUNT() {
        return process.env.VUE_APP_CLOUDINARY_ACCOUNT
      },
      menuItem() {
        return this.value
      },
    },
    methods: {
        onAssetSelect(response) {
            this.$refs.assetUploadModal.hide()

            if (response.url) {
                this.emitFieldUpdate({
                    target: {
                        name: 'imageURL',
                        value: response.url,
                    },
                })
            } else {
                console.warn('Ignoring invalid asset selection')
            }
        },
        emitFieldUpdate(event, truthy, falsy) {
            const value = (() => {
              if (event.target.type === 'checkbox') {
                return event.target.checked ? truthy : falsy
              }

              return event.target.value
            })()

            this.$emit("field-update", {
                id: this.id,
                field: event.target.name,
                value,
            })
        },
    },
}
</script>
